module.exports = __webpack_public_path__ + "static/media/cz.052ec527.svg";